import { paths } from '@/routes/paths';

/** Where the plan page lives. Falls back until `paths.student.plan` exists. */
export const PLAN_PATH = paths.student.plan ?? '/student/plan';

export const FREE_PLAN_CODE = 'student-free';

/** The error marker the API puts on a refusal a paid plan would lift. */
export function isPlanLimitError(error) {
  return (error?.errors ?? []).some((item) => item?.code === 'PLAN_LIMIT');
}

/**
 * What a student plan grants, as short lines. Every line is enforced by the
 * backend; `null` is unlimited.
 */
export function studentPlanLines(entitlements) {
  if (!entitlements) return [];
  const allowance = (value, noun) =>
    value == null
      ? { text: `Unlimited ${noun}`, included: true }
      : { text: `${value} ${noun} a month`, included: true };
  return [
    allowance(entitlements.ai_cv_reviews_per_month, 'AI CV reviews'),
    allowance(entitlements.ai_roadmaps_per_month, 'AI career roadmaps'),
    allowance(entitlements.applications_per_month, 'applications'),
    entitlements.application_boost
      ? { text: 'Premium badge on your applications', included: true }
      : { text: 'No Premium badge for companies', included: false },
  ];
}

/**
 * How much the yearly plan saves against twelve months of the monthly one,
 * in minor units, or `null` when the pair is not there to compare.
 */
export function yearlySaving(plans) {
  const yearly = plans.find((plan) => plan.price_cents > 0 && plan.interval === 'YEARLY');
  // Only a monthly plan in the same currency is a fair comparison.
  const monthly = plans.find(
    (plan) =>
      plan.price_cents > 0 && plan.interval === 'MONTHLY' && plan.currency === yearly?.currency,
  );
  if (!monthly || !yearly) return null;
  const saving = monthly.price_cents * 12 - yearly.price_cents;
  return saving > 0 ? { code: yearly.code, cents: saving, currency: yearly.currency } : null;
}
